import React, { useContext, useEffect } from "react";
import {
  Layout,
  Button,
  Row,
  Col,
  Typography,
  Form,
  Input,
} from "antd";


import Footerbar from "../sections/Footerbar";
import { AuthContext } from "../context/Auth";
import HeaderBar from "./HeaderBar";

import { useHistory } from 'react-router-dom';

function onChange(checked) {
  console.log(`switch to ${checked}`);
}
const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function SignIn() {
  const { login , user} = useContext(AuthContext);
  const history = useHistory()

  const onFinish = (values) => {
    console.log(values);
    login({
      email:values.email,
      password : values.password,
    });
  };

  useEffect(()=>{
    
    if((user || JSON.parse(localStorage.getItem("user")))){
      history.push('/overview');
    }
  }, [])

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <Layout className="layout-default ant-layout layout-sign-up">
      <HeaderBar/>
        <Content className="landing-header">
          <Row gutter={[24, 0]} justify="space-around !mx-0">
            <Col
              xs={{ span: 24, offset: 0 }}
              lg={{ span: 6, offset: 0 }}
              md={{ span: 12 }}
              className="mt-24 bg-white rounded-lg p-4"
            >
              <h1 className="mb-15 text-center font-bold !text-black text-4xl">Sign In</h1>
              <Title className="font-regular text-muted" level={5}>
                Enter your email and password to sign in
              </Title>
              <Form
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                className="row-col"
              >
                <Form.Item
                  className="username"
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>

                <Form.Item
                  className="username"
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input placeholder="Password" />
                </Form.Item>

                <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ width: "100%" }}
                    >
                      SIGN IN
                    </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </Content>
        <Footerbar bgColorClass="bg-neutral-light" />
      </Layout>
    </>
  );
}
